import { JSONContent } from '@tiptap/core';

import { getMarkdownManager } from './markdownManager';

type TiptapJsonToMarkdownReturn =
  | { ok: true; result: string }
  | { ok: false; error: Error };

// Tiptap JSON → markdown via the single @tiptap/markdown engine (ENG-4659).
// MarkdownManager.serialize IS the editor's own serializer — the exact inverse of
// markdownToTiptapJson's parse — so a JSON↔markdown round-trip stays on one engine
// and can't drift (no parse-new / serialize-old seam). Replaces the prior
// @tiptap/html → turndown pipeline.
export const tiptapJsonToMarkdown = ({
  jsonContent,
}: {
  jsonContent: JSONContent;
}): TiptapJsonToMarkdownReturn => {
  try {
    const result = getMarkdownManager().serialize(jsonContent);

    return {
      ok: true,
      result,
    };
  } catch (error) {
    return {
      ok: false,
      error: error instanceof Error ? error : new Error(String(error)),
    };
  }
};
